/* @generated */
import * as React from "react";
const defaultValue = {
  shouldRenderHumanReadableAttributes: true
};
const HumanReadableAttributesContext = React.createContext(defaultValue);
function useHumanReadableAttributesProvider() {
  return React.useContext(HumanReadableAttributesContext);
}
const HumanReadableAttributesProvider = ({ children, shouldRenderHumanReadableAttributes = true }) => {
  return /* @__PURE__ */ React.createElement(HumanReadableAttributesContext.Provider, { value: { shouldRenderHumanReadableAttributes } }, children);
};
export {
  HumanReadableAttributesContext,
  HumanReadableAttributesProvider,
  useHumanReadableAttributesProvider
};
